import { CREDIT_TYPES } from '../../../utils/constants';
import { OUT_OF_CREDIT_ERROR_TYPES } from './constants';
const calcIsOutOfCredit = (creditObject = {}) => {
    const { total = 0, totalUsed = 0 } = creditObject;
    return total - totalUsed <= 0;
};
const getIsOutOfCreditsByCreditType = (accountCreditsTypes = []) => {
    const emailBalance = accountCreditsTypes.find(creditType => creditType.type === CREDIT_TYPES.EMAIL);
    const isOutOfEmailCredits = calcIsOutOfCredit(emailBalance);
    const phoneBalance = accountCreditsTypes.find(creditType => creditType.type === CREDIT_TYPES.PHONE);
    const isOutOfPhoneCredits = calcIsOutOfCredit(phoneBalance);
    return { isOutOfEmailCredits, isOutOfPhoneCredits };
};
const getLimitType = (isOutOfEmailCredits, isOutOfPhoneCredits) => {
    if (isOutOfEmailCredits && isOutOfPhoneCredits) {
        return CREDIT_TYPES.BOTH;
    }
    if (isOutOfEmailCredits) {
        return CREDIT_TYPES.EMAIL;
    }
    if (isOutOfPhoneCredits) {
        return CREDIT_TYPES.PHONE;
    }
    return '';
};
const getLimitTypeByFailedShowMessage = (errorMessage, isOutOfEmailCredits, isOutOfPhoneCredits) => {
    const isBothCreditsError = errorMessage === OUT_OF_CREDIT_ERROR_TYPES.BOTH;
    const isPhoneCreditsError = errorMessage === OUT_OF_CREDIT_ERROR_TYPES.PHONE || errorMessage === OUT_OF_CREDIT_ERROR_TYPES.OVER_USE_PHONE;
    const isEmailCreditsError = errorMessage === OUT_OF_CREDIT_ERROR_TYPES.EMAIL || errorMessage === OUT_OF_CREDIT_ERROR_TYPES.OVER_USE_PHONE;
    const isEmailCreditsMissMatch = isEmailCreditsError && !isOutOfEmailCredits;
    const isPhoneCreditsMissMatch = isPhoneCreditsError && !isOutOfPhoneCredits;
    const isBothCreditsMissMatch = isBothCreditsError && !isOutOfEmailCredits && !isOutOfPhoneCredits;
    if (isBothCreditsMissMatch || isPhoneCreditsMissMatch || isEmailCreditsMissMatch) {
        return '';
    }
    return getLimitType(isOutOfEmailCredits, isOutOfPhoneCredits);
};
export { calcIsOutOfCredit, getIsOutOfCreditsByCreditType, getLimitType, getLimitTypeByFailedShowMessage };
